import axios from 'axios';

export async function FHIRApi(patientName, patientId) {
    var patientRequest = '';
    // const baseURL = 'https://fhir.s37vcloskatg.static-test-account.isccloud.io/Patient';
    // const baseURL = 'https://hapi.fhir.org/baseR4/Patient';
    const baseURL = 'https://sandbox.consint.ai/fhir/Patient';
    // patientRequest = baseURL + '/' + patientId + '/$everything'
    if (patientName !== '') {
        patientRequest = baseURL + '?name=' + patientName;
    }
    else {
        patientRequest = baseURL + '/' + patientId + '/$everything?_count=900';
    }

    const request = {
        url: patientRequest,
        method: 'GET',
        // headers: {
        //     'X-Powered-By': 'sJdH2KXzI14lWunvyxTQhEDQLTf54z396LtIyVya'
        // }
    };
    // const request = {
    //     url: patientRequest,
    //     method: 'GET',
    //     headers: {
    //         'X-Api-Key': 'sJdH2KXzI14lWunvyxTQhEDQLTf54z396LtIyVya'
    //     }
    // };

    return axios.request(request).then(res => {
        return res.data
    }).catch(error => {
        throw new Error(error);
    });
}

export async function login(image) {
    const loginAPI = 'https://backend.biometric.althea.ai/login';
    if (image !== undefined) {
        const body = {
            image: image,
        };

        const request = {
            url: loginAPI,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(body)
        };

        return axios
            .request(request)
            .then((res) => {
                return res.data;
            })
            .catch((error) => {
                throw new Error(error);
            });
    }
}


export const givePersonDataById = async (id) => {
    const { data } = await axios.get(`https://backend.biometric.althea.ai/users/${id}`)
    return data
}
export const sendOtp = async (aadhaar_number) => {
    const { data } = await axios.post("https://backend.biometric.althea.ai/sendOTP", {
        aadhaar_number
    })
    return data
}

export const verifyOtp = async (otp, ref_id) => {
    const { data } = await axios.post("https://backend.biometric.althea.ai/verifyOTP", {
        otp,
        ref_id
    })
    return data
}

export const registerData = async (registerObj) => {
    const { data } = await axios.post("https://backend.biometric.althea.ai/register", registerObj)
    return data
}


export const sendImagesToModel = async (uid, face) => {
    const { data } = await axios.post("https://backend.biometric.althea.ai/train", {
        uid,
        face
    })
    return data
}


export const getPatientById = async (id) => {
    try {
        const { data } = await axios.get(`https://sandbox.consint.ai/fhir/Patient/${id}`)
        return data
    } catch (error) {
        return
    }
}